import { useQuery } from '@apollo/client';
import { useState } from 'react';
import styled from 'styled-components';

import { FatPendingCommitmentsPageAllocationOwnersQuery } from '@/__generated__/graphql';
import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import Select from '@/components/basicComponents/select';
import { createSimpleSelectOption } from '@/components/basicComponents/select/utils';
import { OWNERS_QUERY } from '../queries';
import { IRowData } from '../types';

interface EditOwnerProps {
  onClose: () => void;
  updateAllocationOwners: (variables: any) => void;
  isOpen: boolean;
  allocation: IRowData | null;
  refetch: any;
}

const EditOwner = ({ onClose, updateAllocationOwners, isOpen, allocation, refetch }: EditOwnerProps) => {
  const [advisor, setAdvisor] = useState(`${allocation?.advisorOwner?.firstName ?? ''} ${allocation?.advisorOwner?.lastName ?? ''}`);
  const [operations, setOperations] = useState(`${allocation?.operationsOwner?.firstName ?? ''} ${allocation?.operationsOwner?.lastName ?? ''}`);

  const { data } = useQuery(OWNERS_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'no-cache',
    variables: {
      id: allocation?.id
    }
  });

  const saveSelectors = () => {
    const [advisorFirstName, advisorLastName] = advisor.split(' ');
    const [operationsFirstName, operationsLastName] = operations.split(' ');
    const newAdvisorOwner = data.AllocationOwners.advisorOwners.find(
      (advisorOwner: FatPendingCommitmentsPageAllocationOwnersQuery['AllocationOwners']['advisorOwners'][number]) =>
        advisorOwner.firstName === advisorFirstName && advisorOwner.lastName === advisorLastName
    );
    const newOperationsOwner = data.AllocationOwners.operationsOwners.find(
      (operationsOwner: FatPendingCommitmentsPageAllocationOwnersQuery['AllocationOwners']['operationsOwners'][number]) =>
        operationsOwner.firstName === operationsFirstName && operationsOwner.lastName === operationsLastName
    );
    updateAllocationOwners({
      variables: {
        data: {
          id: allocation.id,
          advisorOwnerId: newAdvisorOwner?.id,
          operationsOwnerId: newOperationsOwner?.id
        }
      }
    });
    onClose();
  };

  const shouldDisabledSave = !data?.AllocationOwners?.advisorOwners?.length && !data?.AllocationOwners?.operationsOwners?.length;

  if (!allocation) return <></>;

  return (
    <ModalWrappedContent
      isOpen={isOpen}
      onClose={onClose}
      title={'Edit Owner'}
      confirmButton={{ name: 'Save', onClick: saveSelectors, disabled: shouldDisabledSave }}
      showRequiredFields
    >
      <Selectors>
        <Select
          value={advisor}
          setValue={setAdvisor}
          options={
            data?.AllocationOwners?.advisorOwners?.map(
              (owner: FatPendingCommitmentsPageAllocationOwnersQuery['AllocationOwners']['advisorOwners'][number]) =>
                createSimpleSelectOption(`${owner.firstName} ${owner.lastName}`)
            ) || []
          }
          styleType={!data?.AllocationOwners?.advisorOwners.length ? 'disabled' : 'default'}
          label="Advisor"
          size="md"
          isRequiredField
        />
        <Select
          value={operations}
          setValue={setOperations}
          options={
            data?.AllocationOwners?.operationsOwners?.map(
              (owner: FatPendingCommitmentsPageAllocationOwnersQuery['AllocationOwners']['operationsOwners'][number]) =>
                createSimpleSelectOption(`${owner.firstName} ${owner.lastName}`)
            ) || []
          }
          styleType={!data?.AllocationOwners?.operationsOwners.length ? 'disabled' : 'default'}
          label="Operations"
          size="md"
          isRequiredField
        />
      </Selectors>
    </ModalWrappedContent>
  );
};

export default EditOwner;

const Selectors = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 10px;
`;
